module.exports = __webpack_public_path__ + "static/AzoSans-Regular-5d0ac72f13731d19a7d2f2bc88b9228b.ttf";